import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_CATEGORIES,
  CREATE_CATEGORY_REQUEST,
  DELETE_CATEGORY,
} from "./actionTypes";
import {
  fetchCategories,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
  createCategorySuccess,
  createCategoryFailure,
  deleteCategorySuccess,
  deleteCategoryFailure,
} from "./actions";
import { get, post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Categories
function* fetchCategoriesSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_GET_CATEGORIES, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve categories!");
    }
    yield put(fetchCategoriesSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchCategoriesFailure(error.message));
  }
}

// Create Category Saga
function* createCategorySaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_CREATE_CATEGORY, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Category saved successfully!",
      });
      yield put(createCategorySuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchCategories(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createCategoryFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the category",
    });
    yield put(createCategoryFailure(error.message));
  }
}

function* deleteCategorySaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_DELETE_CATEGORY, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response.message || "Category deleted successfully!",
      });
      yield put(deleteCategorySuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete category!",
      });
      yield put(deleteCategoryFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Category Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the category",
    });
    yield put(deleteCategoryFailure(error.message));
  }
}

// Watcher Saga
function* categorySaga() {
  yield takeEvery(FETCH_CATEGORIES, fetchCategoriesSaga);
  yield takeEvery(CREATE_CATEGORY_REQUEST, createCategorySaga);
  yield takeEvery(DELETE_CATEGORY, deleteCategorySaga);
}

export default categorySaga;
